import { render, staticRenderFns } from "./PerformanceTargetEdit.vue?vue&type=template&id=90e2413e"
import script from "./PerformanceTargetEdit.vue?vue&type=script&lang=js"
export * from "./PerformanceTargetEdit.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports